import {Apollo, gql} from 'apollo-angular';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { HybridToolsService } from '../../../core/services/hybrid-tools.service';
import {DatagridComponent} from "../../../ui/datagrid/datagrid.component";
import * as moment from 'moment';
import {EventService} from "../../../core/services/event.service";
import {ActivatedRoute} from "@angular/router";
import {DatatableService} from "../../../core/services/datatable.service";

import {AuthenticationService} from "../../../authentication/authentication.service";

import {ProgressService} from "../../../core/services/progress.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import {ImageService} from "../../../core/services/image.service";
import { Angulartics2 } from "angulartics2";
import {PageService} from '../../../core/services/page.service';
import {NationalTeamsService} from '../../../core/services/national-teams.service';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-posts',
    templateUrl: './posts.component.html',
    styleUrls: ['../edit-page.component.scss']
})
export class PostsComponent implements OnInit, AfterViewInit {
    postInEditMode: any = {};
    isEditPost: boolean;
    isLoaded = false;
    deleteBtn: any; // jQuery

    @ViewChild('postsTable', { static: false }) datagrid: DatagridComponent;
    @Output() onPostFormReady: EventEmitter<NgForm> = new EventEmitter();

    @Input() isPastItemPage: boolean;

    postsGridOptions: any = {
        data: [],
        columns: [
            {
                title: 'Date',
                data: 'date',
                type: 'date',
                render: (x) => {
                    return x ? moment.utc(x).format('MM/DD/YYYY') : 'N/A';
                }
            },
            {
                title: 'Title',
                data: 'title',
                responsivePriority: 1
            }
        ]
    };

    constructor(
        public eventService: EventService,
        public route: ActivatedRoute,
        private datatableService: DatatableService,
        private apollo: Apollo,
        private authService: AuthenticationService,
        private cd: ChangeDetectorRef,
        private progressService: ProgressService,
        private http: HttpClient,
        private ToastrService: ToastrService,
        private imageService: ImageService,
        private angulartics2: Angulartics2,
        private pageService: PageService,
        private hybridToolsService: HybridToolsService,
        private nationalTeamsService: NationalTeamsService
    ) {}

    ngOnInit() {
        const isNationalTeam = !!this.route.snapshot.queryParams['isNationalTeamPage'];
        if (!isNationalTeam) {
            this.postsGridOptions.columns.push({
                title: 'Comments',
                data: 'comments'
            });
        }
        this.postsGridOptions.columns.push({
            title: 'Status',
            data: 'status'
        });
        if (!this.isPastItemPage) {
            this.postsGridOptions.columns.unshift({
                type: 'checkbox',
                idProperty: 'postId',
                class: 'text-center',
                data: 'checked',
                width: '5%',
                sortable: false,
                responsivePriority: 1
            });
            this.postsGridOptions.columns.unshift({
                className: 'control',
                sortable: false,
                render: (x) => {
                    return '';
                }
            })

            this.postsGridOptions.columns.push({
                title: 'Manage',
                data: 'status',
                orderable: false,
                responsivePriority: 1,
                render: function (d) {
                    if(d === 'Published') {
                        return '<a class="edit-post">Edit</a><a class="view-post">View</a>';
                    } else {
                        return '<a class="edit-post">Edit</a>';
                    }

                },
                class: 'excludeExport'
            });

            const me = this;
            this.postsGridOptions.addButtons = [{
              text: "Delete Selected",
              className: 'btn btn-primary btn-sm ui-create-post',
              action: function () {
                me.deleteSelected();
              },
              enabled: false,
              init: function ( dt, node, config ) { me.deleteBtn = node;}
            }, {
              text: "Create post",
              className: 'btn btn-primary btn-sm ui-create-post',
              action: function () {
                me.createPost();
              },
            }];

            this.postsGridOptions.order = [[ 2, "desc" ]];
        }
    }

    ngAfterViewInit() {
        this.reloadPosts();
    }

    // Reloads the posts section from GraphQL
    reloadPosts() {
        this.progressService.startProgress(false);
        const isNationalTeam = !!this.route.snapshot.queryParams['isNationalTeamPage'];
        const isTeam = !!this.route.snapshot.queryParams['isTeam'];
        var partialQuery;
        if (isNationalTeam) {
            const nationalTeamId = this.nationalTeamsService.selectedNationalTeam.teamId;
            partialQuery = `NationalTeam(teamId: ${nationalTeamId}) {
                fundraiser {
                  fundraiserPosts {
                    fundraiserPostId
                    publishedFl
                    urlKey
                    rawHtmlContent
                    htmlContent
                    publishedDate
                    title
                  }
                }
              }`;
        } else if (isTeam) {
            let teamId = this.eventService.selectedEvent.gql.Participant[0].team.teamId;
            partialQuery = `Team (teamId: ${teamId}) {
                fundraiser {
                  fundraiserPosts {
                    fundraiserPostId
                    publishedFl
                    urlKey
                    rawHtmlContent
                    htmlContent
                    publishedDate
                    title
                    fundraiserPostComments {
                       comment
                    }
                  }
                }
              }`;
        } else {
            let participantId = this.eventService.selectedEvent.participantId;
            partialQuery = `Participant (participantId: ${participantId}){
                        participantId
                        individualConstituent {
                          individualConstituentId
                        }
                        event {
                          eventId
                        }
                        fundraiser {
                          fundraiserPosts {
                            fundraiserPostId
                            publishedFl
                            urlKey
                            rawHtmlContent
                            htmlContent
                            publishedDate
                            title
                            fundraiserPostComments {
                                comment
                            }
                          }
                        }
                      }`;
        }
        var query = gql`
                  query ReloadPagePostsQuery {
                    ${partialQuery}
                  }`;

        this.apollo.query<any>({
            fetchPolicy: "network-only",
            query: query
        }).subscribe(res => {
            if (isNationalTeam) {
                this.nationalTeamsService.selectedNationalTeam.fundraiser.fundraiserPosts = res.data.NationalTeam[0].fundraiser.fundraiserPosts;
                this.parsePosts(res.data.NationalTeam[0].fundraiser.fundraiserPosts);
            } else if (isTeam) {
                this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserPosts = res.data.Team[0].fundraiser.fundraiserPosts;
                this.parsePosts(res.data.Team[0].fundraiser.fundraiserPosts);
            } else {
                this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserPosts = res.data.Participant[0].fundraiser.fundraiserPosts;
                this.parsePosts(res.data.Participant[0].fundraiser.fundraiserPosts);
            }
            this.progressService.stopProgress(false);
            this.rowsSelected([]);
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 500);
        });
    }

    currentPagePosts() {
        const isNationalTeam = !!this.route.snapshot.queryParams['isNationalTeamPage'];
        const isTeam = !!this.route.snapshot.queryParams['isTeam'];
        if (!!isNationalTeam) {
            return this.nationalTeamsService.selectedNationalTeam.fundraiser.fundraiserPosts;
        } else if (!!isTeam) {
            return this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserPosts;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserPosts;
        }
    }

    getCurrentPageFullUrl() {
        const isNationalTeam = !!this.route.snapshot.queryParams['isNationalTeamPage'];
        const isTeam = !!this.route.snapshot.queryParams['isTeam'];
        if (!!isNationalTeam) {
            return this.nationalTeamsService.selectedNationalTeam.fundraiser.fullUrl;
        } else if (!!isTeam) {
            return this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fullUrl;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].fundraiser.fullUrl;
        }
    }

    parsePosts(posts) {
        let data = [];
        const isNationalTeam = !!this.route.snapshot.queryParams['isNationalTeamPage'];

        posts.forEach(row => {
            let baseUrl = null;
            if (!!isNationalTeam) {
                baseUrl = this.nationalTeamsService.selectedNationalTeam.campaign.programGroup.baseUrl;
            } else {
                baseUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.baseUrl;
            }

            let htmlContent;

            if (row.htmlContent) {
                htmlContent = row.htmlContent.replace(this.imageService.getUpdateImageRegex(''),'$1' + baseUrl + '$3');
            }

            let postItem = {
                postId: row.fundraiserPostId,
                date: row.publishedDate,
                title: row.title,
                status: row.publishedFl ? 'Published' : 'Draft',
                html: htmlContent,
                url: row.urlKey
            };
            if (!isNationalTeam) {
                postItem['comments'] = row.fundraiserPostComments.length;
            }
            data.push(postItem);
        });
        if (this.postsGridOptions.data && this.datagrid) {
            this.datatableService.replaceData(this.datagrid, data);
        } else {
            this.postsGridOptions.data = data;
        }
        this.isLoaded = true;
        this.cd.detectChanges();
        this.datagrid.bindClick('.edit-post', (event) => {
            var tr = $(event.target).closest('tr');
            var row = this.datagrid.dtInstance.row(tr);
            this.editPost(row.data());
        });

        this.datagrid.bindClick('.view-post', (event) => {
            var tr = $(event.target).closest('tr');
            var row = this.datagrid.dtInstance.row(tr);
            this.hybridToolsService.openExternalLink(this.getCurrentPageFullUrl() + '#' + row.data().url);
        });
    }

    deleteSelected() {
        let deletedPosts = this.datatableService.deleteSelected(this.datagrid);
        let postIds = deletedPosts.map(o => {
            return o.postId;
        });
        this.http.post('/api/v1/posts/?delete=', postIds).subscribe(() => {
            this.ToastrService.success("Post(s) deleted.");
            this.angulartics2.eventTrack.next({
                action: 'Delete Post',
                properties: {category: 'Fundraising Pages: Posts'}
            });
            this.reloadPosts();
        }, err => {
            this.ToastrService.error("Error happened during deletion.");
        });
    }

    editPost(post) {
        this.postInEditMode = post;
        this.isEditPost = true;
    }

    createPost() {
        this.isEditPost = true;
    }

    onEditCancel() {
        this.isEditPost = false;
        this.postInEditMode = {};
        this.datagrid.dtInstance.columns.adjust().draw().responsive.recalc();
    }

    onEditSave() {
        this.isEditPost = false;
        this.reloadPosts();
        this.postInEditMode = {};
    }

    onFormCreated(form: NgForm) {
        this.onPostFormReady.emit(form);
    }

    rowsSelected($event) { // array of selected rows
      const selected = $event.length > 0;
      if (this.deleteBtn) { // the event fires prior init competion
        if (selected) {
          this.deleteBtn.removeClass('disabled');
        } else {
          this.deleteBtn.addClass('disabled');
        }
      }
    }
}
